// extracted by mini-css-extract-plugin
export var currencyInput = "_im-1";
export var currencySymbol = "_im-0";